import React, { useState, useEffect, useMemo } from "react";
import { IPictureModel, IModelError, Nullable } from "../../Common/types";
import { fetcherGET, fetcherPOSTJSON } from "../../Common/Fetch";
import Fetcher from "../../Common/Fetch";
import ChangePasswordModal from "./ChangePasswordModal"
import ChangeEmailModal from "./ChangeEmailModal"
import { IProfileDetailsModel, IPersonalInfo, ISelectListItem } from "./types";

import useGetDetails from "../../Api/useGetDetails";
import useDataStore from "../../Hooks/useDataStore";
import usePostSaveProfileDetails from "../../Api/usePostSaveProfileDetails";
import Input from "../../FormUi/Input";
import { Field } from "../../Types/Form";
import Loading from "../../Ui/Loading";
import Popup from "../../Popups/Popup";
import { forEach } from "lodash";
import axios from "axios";
import { useValidate } from "../../Hooks/useValidate";

function BankDetails() {
    const [head, setHead] = useState({});
    const [isOpen, setIsOpen] = useState(false);

    const [vals, setVals] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isLoad, setIsLoad] = useState(false);

    const { validate, errors } = useValidate([
        { key: "Title", name: "Название" },
        { key: "BIK", name: "БИК", fn: (val) => val?.length == 9, text: "БИК должен состоять из 9 символов" },
        { key: "Giro", name: "Расчётный счёт", fn: (val) => val?.length == 20, text: "Расчетный счёт должен состоять из 20 символов" },
        { key: "INN", name: "ИНН", fn: (val) => val?.length >= 10 && val?.length <= 12, text: "ИНН должен состоять из 10 / 12 символов" },
        { key: "BankName", name: "Наименование банка" },
        { key: "KPP", name: "КПП" },
        { key: "CorrespondentAccount", name: "Кор. счёт" }
    ]);

    const {
        data,
        isFetching: isGetDetailsLoading,
        isError: isGetDetailsError,
        error: getDetailsError,
        refetch: getDetails
    } = useGetDetails();

    const {
        mutate,
        isPending,
        isError,
        isSuccess,
        error
    } = usePostSaveProfileDetails();


    useEffect(() => {
        if (data) {
            if (data.profileDetails.BankData.length && data.profileDetails.BankData !== null) {
                data.profileDetails.BankData.map(item => {
                    var group = {};
                    console.log('item=', item);
                    group.Title = item.Title;
                    group.Id = item.Id;
                    group.Fields = [
                        { name: "Title", title: "Название", editable: true, initialValue: item.Title || "" },
                        { name: "BankName", title: "Наименование банка", editable: true, initialValue: item.BankName || "" },
                        { name: "BIK", title: "БИК", editable: true, initialValue: item.BIK || "" },
                        { name: "Giro", title: "Расчётный счёт", editable: true, initialValue: item.Giro || "" },
                        { name: "KPP", title: "КПП", editable: true, initialValue: item.KPP || "" },
                        { name: "CorrespondentAccount", title: "Кор. счёт", editable: true, initialValue: item.CorrespondentAccount || "" },
                        { name: "INN", title: "ИНН", editable: true, initialValue: item.INN || "" },
                        { name: "IsPrimary", title: "Использовать по умолчанию", initialValue: item?.IsPrimary, element: "checkbox" },
                    ];
                    setVals(prev => [...prev, {
                        Id: item.Id,
                        Title: item.Title,
                        BankName: item.BankName,
                        BIK: item.BIK,
                        Giro: item.Giro,
                        KPP: item.KPP,
                        INN: item.INN,
                        CorrespondentAccount: item.CorrespondentAccount,
                        IsPrimary: item.IsPrimary
                    }]);
                    setGroups(prev => [...prev, group]);
                });
            }    
        }
    }, [data])

    useEffect(() => {
        if (isSuccess) { setHead({ title: "Данные успешно обновлены" }); setIsOpen(true); }
        if (isError) { setHead({ title: "Произошла ошибка" }); setIsOpen(true); }
    }, [isSuccess, isError])

    const update = async (values) => {
        setIsLoad(true);
        try {
            await validate(values);

            let postData = { ...values };
            if (postData.isNew) {
                delete postData.isNew;
                postData.Id = 0;
            }
            console.log(postData);
            try {
                const res = await axios.post("/ProfileApi/UpdateAccountBankRequisite", postData)

                setHead({ title: "Успех", description: "Данные успешно обновлены" });
                setIsOpen(true);
                setIsLoad(false);
                console.log(res);
                setVals([]);
                setGroups([]);
                getDetails();
            } catch (err) {
                console.log(err);
                setHead({ title: "Произошла ошибка" });
                setIsOpen(true);
                setIsLoad(false);
            }

        } catch (errors) {
            setIsLoad(false);
            setIsOpen(true);
            setHead({ title: "Внимание", description: errors.map(i => <><p>{i}</p> <br /></>) });
        }
    }

    return (
        <>
            <h4 className="purpleTextHead">Банковские реквизиты</h4>
            <button className="defaultSmallPinkButton"
                onClick={() => {
                    let group = {};
                    //console.log('item=', item);
                    //group.Title = item.Title;
                    group.Id = Math.random();
                    group.isNew = true;
                    group.Fields = [
                        { name: "Title", title: "Название", editable: true, initialValue: "" },
                        { name: "BankName", title: "Наименование банка", editable: true, initialValue: "" },
                        { name: "BIK", title: "БИК", editable: true, initialValue: "" },
                        { name: "Giro", title: "Расчётный счёт", editable: true, initialValue: "" },
                        { name: "KPP", title: "КПП", editable: true, initialValue: "" },
                        { name: "CorrespondentAccount", title: "Кор. счёт", editable: true, initialValue: "" },
                        { name: "INN", title: "ИНН", editable: true, initialValue: "" },
                        { name: "IsPrimary", title: "Использовать по умолчанию", initialValue: false, element: "checkbox" },
                    ] as Field[];

                    setVals(prev => [...prev, {
                        isNew: true,
                        Id: group.Id,
                        Title: "",
                        BankName: "",
                        BIK: "",
                        Giro: "",
                        KPP: "",
                        CorrespondentAccount: "",
                        INN: "",
                        IsPrimary: false
                    }]);

                    setGroups(prev => [...prev, group]);
                }}
            >Добавить</button>

            {(isPending || isGetDetailsLoading || isLoad) && <Loading />}
            {groups &&
                groups.map(group =>
                    <div className="fields">
                        {/*{console.log('group = ', group)}*/}
                        <p>{group.Title}</p>
                        {/*{console.log('group.Fields=',group.Fields) }*/}
                        {group.Fields.map(field => {
                            //console.log('field=', field);
                            if (field.element === "checkbox") return (
                                <div className={`inputWrapper`}
                                    key={group.Id}
                                >
                                    <label className={error ? `checkbox error` : `checkbox`} htmlFor={group.Id}>
                                        <input
                                            type="checkbox"
                                            id={group.Id}
                                            key={group.Id}
                                            name={field.name}
                                            checked={vals.find(i => i.Id === group.Id)?.IsPrimary}
                                            onChange={(e) => 
                                                setVals(prev => {
                                                    console.log(group);
                                                    const updated = [...prev];
                                                    const index = updated.findIndex(i => i.Id === group.Id);
                                                    console.log(updated[index]);
                                                    if (index !== -1) {
                                                        updated[index][field.name] = !updated[index][field.name];
                                                    }

                                                    console.log(updated);
                                                    return updated;
                                                })    
                                            }
                                        />
                                        <p>{field.title}</p>
                                    </label>
                                </div>
                            )
                            return <Input
                                field={field}
                                value={field?.initialValue}
                                onChange={(name, value) => {
                                    setVals(prev => {
                                        const updated = [...prev];
                                        const index = updated.findIndex(i => i.Id === group.Id);
                                        if (index !== -1) {
                                            updated[index][name] = value;
                                        }
                                        return updated;
                                    })
                                }}
                                onCancel={() => { }}
                            />
                        })}
                        <button
                            onClick={() => update(vals.find(i => i.Id === group.Id))}
                            className="defaultPinkButton"
                        >Сохранить</button>
                    </div>
                )

            }

            <Popup
                head={head}
                isOpen={isOpen}
                close={() => { setIsOpen(false) }}
            />
        </>
    )
}

export default BankDetails;